import {
    InventoryLocationInteraction, InventoryLocationInteractionButtonState,
    InventoryLocationInteractionMode
} from "./interaction";
import {
    drawInventoryLocationStyle,
    inventoryLocationBeatersLineStyle
} from "../../../../map/styles/inventory-locations";
import {EpInventoryLocations} from "../../../../map/layers/inventory-locations";
import {Collection, Feature} from "ol";
import * as turf from "@turf/turf";
import {getLength} from "ol/sphere";
import {LineString, Point} from "ol/geom";
import {fromLonLat, toLonLat} from "ol/proj";
import {Select} from "ol/interaction";

export class InventoryLocationInteractionBeatersLine extends InventoryLocationInteraction {
    /**
     * @param {InventoryLocationInteractionsHandler} handler
     */
    constructor(handler) {
        const layer = new EpInventoryLocations(handler.epMap.map);
        layer.farStyle = null;
        layer.name = 'interaction_beaters_line';
        layer.title = 'Obszary - linie naganki'

        handler.epMap.addCustomLayer(layer)

        super('beaters_line', handler, layer);

        this.dictionary = {
            [InventoryLocationInteractionMode.DRAW]: 'Rysuj linię naganki',
            [InventoryLocationInteractionMode.EDIT]: 'Edytuj linię naganki',
            deleteConfirm: 'Czy na pewno chcesz usunąć linię naganki?',
        };

        if(!handler.locationChosen){
            this.addInitialBeatersLine();
            this.updateSpots();
            this.updateLengthInfo();

            $('input[name="beaters_count"]').change(() => {
                this.updateSpots1();
            })
        }
    }

    draw() {
        super.draw();
        let that = this;

        this.handler.epMap.helpTooltip.set('Aby zakończyć rysowanie linii, kliknij drugi raz w miejsce ostatniego punktu');

        this.addOlInteraction(
            this.epLayer.addDraw({
                noSource: true,
                style: drawInventoryLocationStyle,
                type: 'LineString',
                condition: (e) => {
                    let features = this.handler.epMap.getOlMap().getFeaturesAtPixel(e.pixel, {
                        layerFilter: (layer) => {
                            return layer === this.handler.epMap.boundaries.getLayer();
                        }
                    });
                    return features.length > 0;
                },
                end: function (e) {
                    that.addFeature(e.feature);
                    that.handler.setCurrentInteraction(null);

                    e.feature.setStyle(inventoryLocationBeatersLineStyle)
                }
            })
        )
    }

    edit() {
        super.edit();

        let that = this;
        let previousCoordinates = this.features[0].getGeometry().getCoordinates();

        this.addOlInteraction(
            this.epLayer.addEdit({
                style: drawInventoryLocationStyle,
                features: new Collection(this.features),
                end: function (e) {
                    let feature = e.features.item(0);

                    if (
                        !turf.booleanWithin(
                            turf.lineString(feature.getGeometry().getCoordinates()),
                            that.handler.epMap.boundaries.getBufferedBoundariesPolygon(2)
                        )
                    ) {
                        feature.getGeometry().setCoordinates(previousCoordinates);
                        return;
                    }

                    that.updateFeature(feature);
                    that.updateSpots1();
                    that.updateLengthInfo();
                    previousCoordinates = feature.getGeometry().getCoordinates();
                }
            })
        )
    }

    end(forced) {
        this.updateSpots1();
        this.updateLengthInfo();

        super.end(forced);
    }

    addInitialBeatersLine() {
        let beatersSpotsCoordinates = window._beaters_spots_coordinates;

        if (beatersSpotsCoordinates.length === 2) {
            return;
        }

        this.changeDeleteButtonState(InventoryLocationInteractionButtonState.ON);


        if (typeof beatersSpotsCoordinates === 'string') {
            try {
                beatersSpotsCoordinates = JSON.parse(beatersSpotsCoordinates);
            } catch (error) {
                console.error("Failed to parse coordinates:", error);
                return;
            }
        }

        let coordinatesArray = beatersSpotsCoordinates.map(coord => {
            if (typeof coord === 'string') {
                const [longitude, latitude] = coord.split(' ').map(Number);
                return fromLonLat([longitude, latitude]);
            }
            return fromLonLat(coord);
        });

        let lineFeature = new Feature({
            geometry: new LineString(coordinatesArray),
        });

        lineFeature.setStyle(inventoryLocationBeatersLineStyle);
        this.features = [lineFeature]; // Update the feature array

        this.epLayer.getSource().addFeature(lineFeature);
    }


    updateLengthInfo() {
        let length = 0;
        if(this.features.length) {
            length = getLength(this.features[0].getGeometry()).toFixed(2);
        }

        let beatersCount = $('input[name="beaters_count"]').val();
        $('.beaters_line_length').text(length + 'm');

        let length_value = (length / (parseInt(beatersCount) - 1)).toFixed(2);

        if(length_value<0){
            length_value = 0;
        }
        $('.beaters_distance').text(length_value + 'm');

    }

    updateSpots1() {
        // Clear old features
        let features = this.epLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
        for (let feature of features) {
            this.epLayer.getSource().removeFeature(feature);
        }

        let beatersCount = $('input[name="beaters_count"]').val();
        if (
            !beatersCount ||
            !this.getInput().val().length ||
            beatersCount.length === 0 ||
            parseInt(beatersCount) <= 1
        ) {
            return;
        }

        let points = this.getInput().val().split(" ");
        let coordinatesArray = points.map(coord => coord.split(",").map(a => parseFloat(a)));
        let line = turf.lineString(coordinatesArray);

        let length = turf.length(line, {units: 'meters'})
        let chunkLength = length / (parseInt(beatersCount) - 1);

        let chunks = turf.lineChunk(line, chunkLength, {units: 'meters'})

        features = [];
        let i = 1;
        for (let line of chunks.features) {
            let feature = new Feature({
                geometry: new Point(fromLonLat([line.geometry.coordinates[0][0], line.geometry.coordinates[0][1]])),
            })
            feature.setStyle(inventoryLocationBeatersLineStyle)
            feature.set('type', 'beater')
            feature.set('name', String(i));
            features = [...features, feature]

            i++
        }

        let feature = new Feature({
            geometry: new Point(fromLonLat([line.geometry.coordinates[line.geometry.coordinates.length - 1][0], line.geometry.coordinates[line.geometry.coordinates.length - 1][1]])),
        })
        feature.setStyle(inventoryLocationBeatersLineStyle)
        feature.set('type', 'beater')
        feature.set('name', String(i));
        features = [...features, feature]

        let coordinates = '';
        for (let feature of features) {
            coordinates += ' ' + toLonLat(feature.getGeometry().getCoordinates()).join(',');
        }
        $('input[name="beaters_spots"]').val(coordinates);

        this.epLayer.getSource().addFeatures(features);

        let length_value = (length / (parseInt(beatersCount) - 1)).toFixed(2);

        if(length_value<0){
            length_value = 0;
        }
        $('.beaters_distance').text(length_value + 'm');
    }

    updateSpots() {
        // Clear old features
        let features = this.epLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
        for (let feature of features) {
            this.epLayer.getSource().removeFeature(feature);
        }

        let beatersCoords = JSON.parse(window._beaters_spots_coordinates);

        let beatersCount = $('input[name="beaters_count"]').val();
        if (
            !beatersCount ||
            !this.getInput().val().length ||
            beatersCount.length === 0 ||
            parseInt(beatersCount) <= 1
        ) {
            return;
        }

        // New feature creation, either with beatersCoords or by dividing the line into chunks
        features = [];
        let coordinatesArray;

        // If there are existing coordinates in beatersCoords, use them
        if (beatersCoords && beatersCoords.length > 0) {
            for (let i = 0; i < beatersCoords.length; i++) {
                let [lon, lat] = beatersCoords[i].split(" ").map(coord => parseFloat(coord));

                // Create a feature for each existing beater spot
                let feature = new Feature({
                    geometry: new Point(fromLonLat([lon, lat])),
                });
                feature.setStyle(inventoryLocationBeatersLineStyle);
                feature.set('type', 'beater');
                feature.set('name', String(i + 1));
                features.push(feature);
            }

        } else { // Otherwise, split the line into chunks and place new spots
            let points = this.getInput().val().split(" ");
            coordinatesArray = points.map(coord => coord.split(",").map(a => parseFloat(a)));
            let line = turf.lineString(coordinatesArray);

            let length = turf.length(line, { units: 'meters' });
            let chunkLength = length / (parseInt(beatersCount) - 1);

            let chunks = turf.lineChunk(line, chunkLength, { units: 'meters' });

            let i = 1;
            for (let line of chunks.features) {
                let feature = new Feature({
                    geometry: new Point(fromLonLat([line.geometry.coordinates[0][0], line.geometry.coordinates[0][1]])),
                });
                feature.setStyle(inventoryLocationBeatersLineStyle);
                feature.set('type', 'beater');
                feature.set('name', String(i));
                features.push(feature);
                i++;
            }

            // Add the last feature (endpoint of the line)
            let feature = new Feature({
                geometry: new Point(fromLonLat([line.geometry.coordinates[line.geometry.coordinates.length - 1][0], line.geometry.coordinates[line.geometry.coordinates.length - 1][1]])),
            });
            feature.setStyle(inventoryLocationBeatersLineStyle);
            feature.set('type', 'beater');
            feature.set('name', String(i));
            features.push(feature);
        }

        // Convert the features back to coordinates and update the hidden input field
        let coordinates = '';
        for (let feature of features) {
            coordinates += ' ' + toLonLat(feature.getGeometry().getCoordinates()).join(',');
        }
        $('input[name="beaters_spots"]').val(coordinates.trim());

        // Add all the features back to the map
        this.epLayer.getSource().addFeatures(features);

        // Update distance information
        let length = coordinatesArray ? turf.length(turf.lineString(coordinatesArray), { units: 'meters' }) : 0;
        let length_value = (length / (parseInt(beatersCount) - 1)).toFixed(2);
        if(length_value<0){
            length_value = 0;
        }
        $('.beaters_distance').text(length_value + 'm');
    }

    onDelete(id) {
        super.onDelete(id);

        let features = this.epLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
        for (let feature of features) {
            this.epLayer.getSource().removeFeature(feature);
        }
        window._beaters_spots_coordinates = [];

        $('input[name="beaters_spots"]').val('');
    }

    updateSpotsShow() {
        let features = this.epLayer.getSource().getFeatures().filter(feature => feature.get('type') === 'beater');
        for (let feature of features) {
            this.epLayer.getSource().removeFeature(feature);
        }

        let beatersCoords = JSON.parse(window._beaters_spots_coordinates);

        let beatersCount = beatersCoords.length;

        if (!beatersCoords || beatersCoords.length === 0) {
            return;
        }

        if (
            !beatersCount ||
            beatersCount.length === 0 ||
            parseInt(beatersCount) <= 1
        ) {
            return;
        }

        // Group spots by location_id
        let groupedSpots = beatersCoords.reduce((acc, spot) => {
            acc[spot.location_id] = acc[spot.location_id] || [];
            acc[spot.location_id].push(spot);
            return acc;
        }, {});

        features = [];


        for (let location_id in groupedSpots) {
            let spots = groupedSpots[location_id];
            spots.forEach((spot, index) => {
                let [lon, lat] = [spot.longitude, spot.latitude].map(coord => parseFloat(coord));

                // Create a feature for each spot and number it within its group
                let feature = new Feature({
                    geometry: new Point(fromLonLat([lon, lat])),
                });
                feature.setStyle(inventoryLocationBeatersLineStyle);
                feature.set('type', 'beater');
                feature.set('name', `${index + 1}`); // Use location ID and index for unique numbering
                features.push(feature);
            });
        }

        this.epLayer.getSource().addFeatures(features);

    }
}